<template>
    <div class="font-roboto">
        <div class="wrapper">
            <Breadcrumb :title="this.$t('lbl_EMPBE_Blacklist')"/>
            <div
                class="mb-0 f-24 d-flex justify-content-between align-items-center gap-3 w-100"
            >
                <div class="h6">
                {{ pageDesc }}
                </div>
            </div>
            <Grid></Grid>
        </div>
    </div>
</template>

<script>
    import { Breadcrumb } from "element-ui";
    import Grid from "./component/Grid";

    export default{
        components:{
            Grid
        },
        computed:{
            kendoLang() {
                var langid = localStorage.getItem("currentLangId");
                switch (langid) {
                    case "1252":
                    return "en-US";
                    case "950":
                    return "zh-Hant";
                    case "936":
                    return "zh-Hans";
                    default:
                    return "zh-Hans";
                }
            },
            pageDesc() {
                const localeKey = this.kendoLang;

                    const pageDescMap = {
                        "en-US": "Updating blacklist",
                        "zh-Hant": "更新黑名單",
                        "zh-Hans": "更新黑名单",
                    };

                return pageDescMap[localeKey]; 
            }
        }
        
    }
</script>